export function ucfirst (str) {
  return `${str.substr(0, 1).toUpperCase()}${str.substr(1)}`
}

export function encodeURL (str) {
  return `${str.replace(/\W+/g, '-').toLowerCase()}`
}
